import React, { useEffect, useState } from 'react';
import { useCreateSession } from '../../hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import { Dashboard } from '../dashboard';
import SchedulerPage from '../scheduler-dashboar/scheduler.page';
import { ACCESS_ROUTES, ROUTING_CONFIG } from '../../constants';

export const LandingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSubscribed, setIsSubscribed] = useState(
    JSON.parse(localStorage.getItem('isSubscribed')) || false
  );
  const [isSessionCreated, setIsSessionCreated] = useState(false);
  const handleCreateSession = useCreateSession();

  const createSessionFunction = async (token) => {
    const type = new URLSearchParams(location.search).get('type');
    const payload = { token };
    localStorage.removeItem('sellerToken');
    localStorage.removeItem('marketPlace');
    localStorage.removeItem('isSubscribed');

    const response = await handleCreateSession(payload);
    if (response?.data?.createSessionWithToken) {
      localStorage.setItem(
        'sellerToken',
        response?.data?.createSessionWithToken?.token
      );
      localStorage.setItem(
        'marketPlace',
        response?.data?.createSessionWithToken?.marketplaceUid
      );
      localStorage.setItem(
        'isSubscribed',
        JSON.stringify(response?.data?.createSessionWithToken?.isSubscribed)
      );
      setIsSubscribed(response?.data?.createSessionWithToken?.isSubscribed);
      setIsSessionCreated(true);
    }
    if (response?.data?.createSessionWithToken?.isSubscribed) {
      if (type === ACCESS_ROUTES?.appointments) {
        return navigate(ROUTING_CONFIG?.appointments, { replace: true });
      }
      if (type === ACCESS_ROUTES?.services) {
        return navigate(ROUTING_CONFIG?.service, { replace: true });
      }
      if (type === ACCESS_ROUTES?.categories) {
        return navigate(ROUTING_CONFIG?.schedulerCategories, { replace: true });
      }
      if (type === ACCESS_ROUTES?.clients) {
        return navigate(ROUTING_CONFIG?.clients, { replace: true });
      }
      if (type === ACCESS_ROUTES?.manage_schedule) {
        return navigate(ROUTING_CONFIG?.manageSchedule, { replace: true });
      }
      if (type === ACCESS_ROUTES?.manage_subscription) {
        return navigate(ROUTING_CONFIG?.manageSubscription, { replace: true });
      }

      return navigate(ROUTING_CONFIG?.appointments, { replace: true });
    }
    navigate(location.pathname, { replace: true });
  };

  useEffect(() => {
    if (location?.search) {
      const userToken = new URLSearchParams(location.search).get('token');
      if (userToken) {
        localStorage.setItem('userToken', userToken);
        createSessionFunction(userToken);
      }
    } else {
      const subscribed = JSON.parse(localStorage.getItem('isSubscribed'));
      if (subscribed !== null) {
        setIsSubscribed(subscribed);
      }
    }
  }, [location?.search]);

  return (
    <>
      {isSubscribed ? (
        <Dashboard />
      ) : (
        <SchedulerPage
          isSubscribed={isSubscribed}
          isSessionCreated={isSessionCreated}
        />
      )}
    </>
  );
};
